import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import { Link } from 'react-router-dom'

import { getCurrentSpaceId } from '@/components/App/selectors'
import Button from '@/components/Button'
import Card from '@/components/Card'
import { Role, useRoles } from '@/components/RolesContainer'
import SpaceLanding from '@/components/SpaceLanding'
import PublisherIcon from '@/pages/SpacePublisherPage/PublisherIcon'
import { useAppSelector } from '@/store/hooks'

import messages from './messages'

const LandingStep = ({ onStart }: any) => {
  const intl = useIntl()

  const roles = useRoles()
  const currentSpaceId = useAppSelector(getCurrentSpaceId)

  return (
    <SpaceLanding>
      <SpaceLanding.Header>
        <SpaceLanding.Icon>
          <PublisherIcon />
        </SpaceLanding.Icon>
        <SpaceLanding.Title componentClass="h1" description={intl.formatMessage(messages.title)}>
          <FormattedMessage {...messages.engage} />
        </SpaceLanding.Title>
      </SpaceLanding.Header>
      <SpaceLanding.Body>
        <Card>
          <Card.Header title={<FormattedMessage {...messages.header} />} />
          <Card.Content>
            <div>
              <FormattedMessage {...messages.description} />
            </div>
            <div className="flex space-x-4">
              <Button color="primary" onClick={onStart}>
                <FormattedMessage {...messages.sendButton} />
              </Button>
              {roles.hasSpaceRole(currentSpaceId, Role.SPACE_ADMIN_ROLE) && (
                <Link className="publisher-back-nav" to="notificationsources">
                  <FormattedMessage {...messages.manageSources} />
                </Link>
              )}
            </div>
          </Card.Content>
        </Card>

        <SpaceLanding.Documentation>
          <SpaceLanding.Title description={intl.formatMessage(messages.docPanelMessage)}>
            <FormattedMessage {...messages.new} />
          </SpaceLanding.Title>
          <SpaceLanding.Links>
            <SpaceLanding.Link url="https://help.workgrid.com/s/article/Using-Publisher">
              <FormattedMessage {...messages.introduction} />
            </SpaceLanding.Link>
          </SpaceLanding.Links>
        </SpaceLanding.Documentation>
      </SpaceLanding.Body>
    </SpaceLanding>
  )
}

LandingStep.displayName = 'LandingStep'

LandingStep.propTypes = {
  onStart: PropTypes.func
}

LandingStep.defaultProps = {
  onStart: () => {}
}

export default LandingStep
